import React from "react";
import { AlertTitle, Box, Button, Snackbar, SnackbarProps, Typography } from "@mui/material";
import { Alert } from "@mui/material";
import { SingleAlertInfo, hideSingleAlert } from "../../redux/slice/commonSlice";
import { useAppDispatch } from "../../redux/slice/redux-hooks";

interface CustomSnackbarOrigin {
    vertical: "top" | "bottom";
    horizontal: "left" | "right" | "center";
}

interface CustomAlertProps {
    open: boolean;
    onClose?: () => void;
    singleAlertObj: SingleAlertInfo | null;
    variant?: "filled" | "outlined";
    SnackbarProps?: SnackbarProps;
    autoHideDuration?: number;
    anchorOrigin?: CustomSnackbarOrigin;
}

const CustomSingleAlert: React.FC<CustomAlertProps> = ({
    open,
    onClose,
    singleAlertObj,
    SnackbarProps,
    variant,
    autoHideDuration,
    anchorOrigin,
}) => {

    const dispatch = useAppDispatch();

    const onCloseErrorPopup = () => {
        dispatch(hideSingleAlert());
    }

    const hasInlineButton =
        !!singleAlertObj?.showButton && !!singleAlertObj?.buttonText;

    return (
        <Snackbar
            open={open}
            // autoHideDuration={autoHideDuration || 5000}
            //CS-1297 - Start
            autoHideDuration={
                singleAlertObj?.showButton ? null : (autoHideDuration || 5000)
            }
            //
            onClose={onClose ? onClose : onCloseErrorPopup}
            anchorOrigin={anchorOrigin || { vertical: "top", horizontal: "center" }}
            sx={{ zIndex: 1900 }}
            {...SnackbarProps}
        >
            <Alert
                onClose={onClose ? onClose : onCloseErrorPopup}
                severity={singleAlertObj?.alertType}
                sx={
                    hasInlineButton
                        ? {
                              width: "100%",
                              alignItems: "center",
                              "& .MuiAlert-message": {
                                  flex: 1,
                                  display: "flex",
                                  alignItems: "center",
                              },
                              "& .MuiAlert-action": {
                                  alignItems: "center",
                                  paddingTop: 0,
                              },
                          }
                        : { width: "100%" }
                }
                variant={variant || "filled"}
                action={
                    hasInlineButton ? (
                        <Button
                            onClick={() => {
                                if (singleAlertObj?.onButtonClick) singleAlertObj.onButtonClick();
                                dispatch(hideSingleAlert());
                            }}
                            variant="contained"
                            startIcon={singleAlertObj?.buttonIcon}
                            sx={{
                                // Hardcoded black/white to match the
                                // FixedAlertCard "CREATE IVR" reference,
                                // independent of theme mode.
                                backgroundColor: "#000",
                                color: "#fff",
                                fontWeight: 700,
                                letterSpacing: "0.5px",
                                px: 2,
                                py: 0.75,
                                minWidth: 0,
                                boxShadow: "none",
                                whiteSpace: "nowrap",
                                "&:hover": {
                                    backgroundColor: "#1f1f1f",
                                    boxShadow: "none",
                                },
                            }}
                        >
                            {singleAlertObj?.buttonText}
                        </Button>
                    ) : undefined
                }
            >
                {singleAlertObj?.title &&
                    <AlertTitle>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {singleAlertObj?.title}
                        </Typography>
                    </AlertTitle>}
                {/* CS-1297 — text-only alerts: identical to original layout
                    (just a Typography inside the Alert message slot).
                    Button alerts: button rendered via Alert's action slot
                    above. */}
                {hasInlineButton ? (
                    <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                        <Typography variant="body2" sx={{ wordBreak: "break-word", pr: 2 }}>
                            {singleAlertObj?.message}
                        </Typography>
                    </Box>
                ) : (
                    <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                        {singleAlertObj?.message}
                    </Typography>
                )}
            </Alert>
        </Snackbar>
    );
};

export default CustomSingleAlert;